module.exports = __webpack_public_path__ + "img/recombinant-flag.4195795.svg";